import { useT } from '../i18n/index.ts';

/**
 * Capability statuses the gateway treats as a live pool-row backing (#908) —
 * the set `LIVE_SKU_CAPABILITIES_CTE` admits and the PUT gate re-checks.
 *
 * Single definition on purpose: it drifted into three copies (target dialog,
 * pin dialog, row grouping), and a surface holding a stale copy either offers
 * supply the bind gate will refuse or hides supply that routes fine.
 */
export const LIVE_CAPABILITY_STATUSES: ReadonlySet<string> = new Set([
  'passed',
  'needs_probe',
  'probe_failed',
]);

export function capabilityStatusLabel(status: string | null, t: ReturnType<typeof useT>): string {
  switch (status) {
    case 'passed': return t('tenant_routing.default.capability_status.passed');
    case 'needs_probe': return t('tenant_routing.default.capability_status.needs_probe');
    case 'probe_failed': return t('tenant_routing.default.capability_status.probe_failed');
    case 'missing_from_list': return t('tenant_routing.default.capability_status.missing_from_list');
    case 'mismatch': return t('tenant_routing.default.capability_status.mismatch');
    case 'ignored': return t('tenant_routing.default.capability_status.ignored');
    default: return status ?? t('tenant_routing.target.capability_not_live');
  }
}
